const fragment = (props = {}, emits = []) => ({
    inheritAttrs: false,
    props,
    emits,
    template: '<div><slot></slot></div>',
});

const EmptyCart = {
    props: {labels: {type: Object, default: () => ({})}},
    template: '<div><span class="fs-3">{{ labels.emptyCart }}</span><p>{{ labels.buySomething }}</p></div>',
};

const CartProductList = {
    props: {items: Array, labels: Object, currency: String, formatPrice: Function},
    emits: ['modify-quantity', 'remove'],
    template: `<div><div v-for="(item,index) in items" :key="item.id" class="d-grid d-md-flex pure-g item">
        <div class="pure-u-1-4 pure-u-md-1-8 img-box"><a :href="'${window.SHOP_BASE || ''}/product/0-0/'+item.id"><img class="pure-img" :src="item.image" alt=""></a></div>
        <div class="pure-u-3-4 pure-u-md-3-8 title"><span v-text="item.name"></span><div class="text-grey"><span v-for="characteristic in item.characteristics" :key="characteristic.type_id" class="pr-2" v-text="characteristic.value"></span></div></div>
        <div class="d-none d-md-block pure-u-md-1-8 text-end" v-text="formatPrice(item.price, currency)"></div>
        <div class="pure-u-2-4 pure-u-md-2-8 text-center"><select v-model="item.quantity" @change="$emit('modify-quantity')"><option v-for="quantity in 10" :value="quantity" v-text="quantity == 10 ? '9+' : quantity"></option></select><button type="button" @click="$emit('remove', index)" v-text="labels.remove"></button></div>
        <div class="pure-u-1-4 pure-u-md-1-8 text-end" v-text="formatPrice(item.price * item.quantity, currency)"></div>
    </div></div>`,
};

const CartSummary = {
    props: {totalPrice: Number, stockError: Boolean, labels: Object, currency: String, formatPrice: Function},
    emits: ['order'],
    template: '<div class="pure-u-1-1 pure-u-xl-3-8"><div class="cart-bottom text-end"><div class="fs-3">{{ labels.subtotal }}: <span v-text="formatPrice(totalPrice, currency)"></span></div><p v-if="stockError" class="alert alert-danger" v-text="labels.tooMuch"></p><button type="button" class="btn btn-primary" @click="$emit(\'order\')" v-text="labels.startPayment"></button></div></div>',
};

export default {
    CartStep: fragment({items: Array, totalPrice: Number}),
    CustomerStep: fragment({userData: Object}),
    DeliveryStep: fragment({shipping: Object, country: Object}),
    AddressForm: fragment({address: Object, country: Object}, ['update']),
    PickupPointSelector: fragment({points: Array, selectedPoint: Object}, ['select']),
    DeliveryAddress: fragment({address: Object}, ['update']),
    InvoiceStep: fragment({address: Object, deliveryAddress: Object}),
    PaymentStep: fragment({payment: Object, paymentMethods: Array}),
    PaymentComplete: fragment({order: Object, points: Array}, ['select']),
    EmptyCart,
    CartProductList,
    CartSummary,
};
